import { useEffect, useState, useMemo, lazy, Suspense } from 'react'
import { Provider } from 'react-redux'
import { initializeSnackbar, useSnackbar, SnackbarProvider } from '@aapastech/thridify-blocks'

import { store } from 'apis/arPlaybookApi'
import { GeoProvider } from 'contexts/GeoContext'

const ArPlaybookApp = lazy(() => import('app/ArPlaybookApp'))
const DevToolbar = lazy(() => import('components/DevToolbar'))
const MarketplaceApp = lazy(() =>
    import('modules/marketplace2').then(mod => ({ default: mod.MarketplacePage })),
)

function App() {
    const [pathname, setPathname] = useState(document.location.pathname)

    const isMarketplace = useMemo(() => pathname.startsWith('/marketplace'), [pathname])

    useEffect(() => {
        const handlePathnameChange = () => {
            setPathname(document.location.pathname)
        }
        window.addEventListener('popstate', handlePathnameChange)
        return () => {
            window.removeEventListener('popstate', handlePathnameChange)
        }
    }, [])

    // Marketplace route - isolated from MUI/snackbar but needs Redux for API
    if (isMarketplace) {
        return (
            <Provider store={store}>
                <GeoProvider>
                    <Suspense fallback={<div>Loading...</div>}>
                        <MarketplaceApp />
                    </Suspense>
                </GeoProvider>
            </Provider>
        )
    }

    // Main app with MUI and snackbar
    return (
        <SnackbarProvider>
            <AppWithSnackbar />
        </SnackbarProvider>
    )
}

function AppWithSnackbar() {
    const snackbar = useSnackbar()
    useEffect(() => {
        initializeSnackbar(snackbar)
    }, [snackbar])

    return (
        <>
            <ArPlaybookApp />
            <Suspense fallback={null}>
                <DevToolbar />
            </Suspense>
        </>
    )
}

export default App
